import { useFakedUID } from "./useFakeUID";
import useFirebaseData from "./useFirebaseData";
import type { Segment } from "../types";

const useFirebaseSegment = (segment_id: string) => {
  const uid = useFakedUID();
  return useFirebaseData<Segment>(uid && segment_id ? `/userdata/${uid}/segments/${segment_id}` : null);
};

export default useFirebaseSegment;
